import Head from 'next/head';
import useGetVehicle from '../hooks/useGetVehicle';

const VehicleMeta = () => {
  const { vehicle } = useGetVehicle();

  const description = `${vehicle.brand} ${vehicle.model} ${vehicle.year} ${vehicle.version}`;
  const [previewImage] = vehicle.previewPictures;

  return (
    <Head>
      <script async src="https://static.addtoany.com/menu/page.js" />
      <meta key="og:description" property="og:description" content={description} />
      <meta key="og:image" property="og:image" content={previewImage} />
    </Head>
  );
};

export default VehicleMeta;
